

































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CookieHelper as _cookie } from '@/helper/cookie.helper';
import { Template } from '@/models/template';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({})
export default class SelectStorePage extends Base {
  public stores: any[] = [];
  public selectedStoreId: number = 0;
  public loading: boolean = false;
  public storeLoading: boolean = false;

  public logoPath: string;

  public created() {
    // this.logoPath = require("@/assets/"+Utils.AppEnvironmentName+"logo-1.png");
    this.logoPath = Utils.blobBaseUrl + "logo-1.png";
  }
  public mounted() {
    this.getUserStores();
  }
  public async getUserStores(): Promise<void> {
    try {
      this.storeLoading = true;
      const stores = await storeService.getUserStores();
      this.stores = stores.results;
    } finally {
      this.storeLoading = false;
    }
  }

  public async changeStore(): Promise<void> {
    try {
      this.loading = true;
      const store = this.stores.find((st) => {
        return st.storeId === this.selectedStoreId;
      });

      if (store && store.storeId > 0) {
        this.$store.dispatch('setStoreName', store.name);
      }

      await storeService.storeSwitch(
        store.tenantId,
        store.enterpriseId,
        store.storeId
      );
      if (store && store.storeId > 0) {
        const features = await storeService.getStoreFeatures();
        _cookie.setCookie('StoreFeatures', JSON.stringify(features.results));
      }

      // set localization according to
      if (this.isFeatureToAccess('LOCALIZATION')) {
        const lang = _cookie.getCookie('lang')
          ? _cookie.getCookie('lang')
          : 'en';
        this.$i18n.locale = lang;
        _cookie.setCookie('lang', lang);
      } else {
        const lang = 'en';
        this.$i18n.locale = lang;
        _cookie.setCookie('lang', lang);
      }
      this.$store.dispatch('setTenantInfo', {
        tenantId: store.tenantId,
        enterpriseId: store.enterpriseId,
        storeId: store.storeId,
      });

      if (store.storeId) {
        if (this.$route.query && this.$route.query.redirectUrl) {
          this.$router
            .push({ path: String(this.$route.query.redirectUrl) })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          this.$router
            .push({
              name: 'app.dashboard',
              params: {
                tenantId: store.tenantId,
                enterpriseId: store.enterpriseId,
                storeId: store.storeId,
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
